module.exports = __webpack_public_path__ + "static/media/82.5ffe9d26.png";